const autoScrollToCategory = (e) => {
  const builder = document.querySelector('#product-builder');
  const matchOptionId = "ka_2eHb8O0Z-3-TRH8hiAfzp";
  const activatedOptionId = e.detail.option.id;  
  
  if (activatedOptionId !== matchOptionId) return;

  setTimeout(() => {
    const categoryForScroll = document.querySelector('.cpb-category[data-category-id="Fb2f9BHuyMjUTTapDBaHhcj7"]');
    if (categoryForScroll && !builder.classList.contains('cpb-fix-image')) {
      categoryForScroll.style.scrollMarginBottom = '150px';
      categoryForScroll.scrollIntoView({ block: "end", behavior: "smooth" });
    }
  }, 80);
};

const createHint = () => {
  const product = CPB.getStore().getState().Product;
  const categoriesWithDescr = product.panels.flatMap(panel => panel.categories.filter(category => category.description));

  if (categoriesWithDescr.length === 0) return;

  const tabChangeHandler = () => {
    categoriesWithDescr.forEach(category => {
      const catElem = document.querySelector(`.cpb-category[data-category-id="${category.id}"]`);
      if (!catElem) return;
      
      const hintHTML = category.description;
      const hintIcon = document.createElement("span");
      hintIcon.classList.add("cpb-hint-icon");
      
      hintIcon.innerHTML = `
        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.11 7.43V8.12H3.06V7.22C3.06 6.71 3.16 6.29 3.36 5.96C3.57 5.62 3.87 5.28 4.26 4.94L4.68 4.565C5.26 4.095 5.55 3.54 5.55 2.9C5.55 2.35 5.37 1.92 5.01 1.61C4.66 1.29 4.215 1.13 3.675 1.13C3.155 1.13 2.72 1.295 2.37 1.625C2.03 1.945 1.82 2.365 1.74 2.885L0.72 2.705C0.87 1.935 1.215 1.325 1.755 0.875C2.295 0.425 2.95 0.2 3.72 0.2C4.55 0.2 5.24 0.435 5.79 0.904999C6.35 1.375 6.63 2.02 6.63 2.84C6.63 3.25 6.56 3.615 6.42 3.935C6.28 4.255 6.13 4.5 5.97 4.67C5.81 4.84 5.57 5.055 5.25 5.315C4.8 5.685 4.495 6 4.335 6.26C4.185 6.52 4.11 6.91 4.11 7.43ZM4.26 9.71C4.42 9.87 4.5 10.06 4.5 10.28C4.5 10.5 4.42 10.69 4.26 10.85C4.11 11.01 3.92 11.09 3.69 11.09C3.46 11.09 3.265 11.01 3.105 10.85C2.955 10.69 2.88 10.5 2.88 10.28C2.88 10.06 2.955 9.87 3.105 9.71C3.265 9.55 3.46 9.47 3.69 9.47C3.92 9.47 4.11 9.55 4.26 9.71Z" fill="#CCD5D0"/>
        </svg>
      `;
      
      hintIcon.addEventListener('click', () => {
        Swal.fire({
          confirmButtonText: 'Ok',
          html: hintHTML
        });
      });
      
      catElem.querySelector('.cpb-category-title__inner')?.appendChild(hintIcon);
    });
  };

  document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', tabChangeHandler);
  tabChangeHandler();
};

const setClarityMask = () => {
  document.querySelectorAll('canvas[data-type="image"]').forEach(layer => {
    layer.setAttribute('data-clarity-unmask', 'true');
  });
};

document.body.addEventListener('PRODUCT_BUILDER_OPTION_ACTIVATE', autoScrollToCategory);
document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
  createHint();
  setClarityMask();
});
